import initVideo from "components/jiffy/product-video/product-video";

document.addEventListener("DOMContentLoaded", () => {
  initVideo();
});
